/** @format */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { fixedFunding, uuidv4 } from "../../../../utils/helper";
import {
  Table,
  Space,
  Form,
  Modal,
  Button,
  Select,
  Input,
  InputNumber,
} from "antd";
import { BreadCrumb } from "../../../../components";
import { formatRupiah } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  ButtonLog,
  ButtonTableDelete,
  ButtonTableEdit,
  ButtonTambah,
} from "../../../../components/Button";
import InputSearch from "../../../../components/InputSearch";
import { NotifMessage } from "../../../../components/NotifMessage";
import {
  deleteRencanaPedapatanIndikatif,
  getRencanaPendapatanIndikatifLisAlokasi,
  postRencanaPendapatanIndikatif,
  editRencanaPendapatanIndikatif,
} from "../../../../services/v2/planningservice/rencanapendapatanindikatif";
import { setStore } from "../../../../redux/actions";
import { getPlanningAll } from "../../../../services/v2/planningservice";

export const baseURL: string =
  window.REACT_APP_API_URL ||
  "https://staging-api-gateway.erkam-v2.kemenag.go.id/api";
export const publicURL: string =
  window.REACT_APP_PUBLIC_URL ||
  "https://staging-frontend.erkam-v2.kemenag.go.id/";
/**
 * Tampilan awal pagu indikatif pendapatan
 */
function PaguIndikatifPendapatan() {
  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    { path: "/", breadcrumbName: "Rencana" },
    { path: "/", breadcrumbName: "Pagu Indikatif" },
    { path: "/", breadcrumbName: "Pendapatan" },
  ];
  // let apbnBosSemester: any = ["apbn_bos_semester_1", "apbn_bos_semester_2"];
  const route = useHistory();
  const [form] = Form.useForm();
  const auths = useSelector((state: any) => state.auth);
  const store = useSelector((state: any) => state.store);
  const dispatch = useDispatch();
  const auth = auths?.data || null;
  const kodeRole = auth?.kode_role;
  const storeSumberDana: any = store.sumberDana || [];
  const tmpRencanaPendapatanIndikatif = store.rencanaPendapatanIndikatif || [];
  const tmpRencanaTanggal = store.rencanaTanggal || [];
  const tmpRencanaTanggalBkba = store.rencanaTanggalBkba || [];

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [id, setID] = useState("");
  const [title, setTitle] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [search, setSearch] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [btnAction, setBtnAction] = useState(false);
  // const [enabledNilai, setEnabledNilai] = useState(false);

  const tmpFilterSumberDana = tmpRencanaPendapatanIndikatif
    .filter((item: any) => !item.id.includes(id))
    .map((item: any) => item.kode_sumber_dana);

  /** Filter Search */
  let dataTable: any = search
    ? tmpRencanaPendapatanIndikatif.filter((item: any) => {
        const val = search.toLowerCase();
        return (
          (item.nama_sumber_dana !== null &&
            (item.nama_sumber_dana || "")
              .toString()
              .toLowerCase()
              .includes(val)) ||
          (item.keterangan !== null &&
            (item.keterangan || "").toString().toLowerCase().includes(val))
        );
      })
    : tmpRencanaPendapatanIndikatif;
  let totalDataTable = dataTable.length;
  /**
   * Filter Pagination
   */
  dataTable = dataTable.filter((v, i) => {
    let start = pageSize * (page - 1);
    let end = start + pageSize;

    return i >= start && i < end;
  });

  /**
   * Filter Sumber Dana By status Madrasah
   */
  const tmpSumberDana =
    auth?.madrasah?.status === "n"
      ? storeSumberDana.filter((item: any) => item.madrasah_n === "1")
      : auth?.madrasah?.status === "ra"
      ? storeSumberDana.filter((item: any) => item.ra === "1")
      : storeSumberDana.filter((item: any) => item.madrasah_s === "1");

  /**
   * Data untuk tabel children pertama
   */
  let columns: any = [
    {
      title: "Tahun",
      dataIndex: "tahun",
      key: "tahun",
      onFilter: (value, record) => record.tahun.indexOf(value) === 0,
      sorter: (a, b) => a.tahun - b.tahun,
    },
    {
      title: "Sumber Dana",
      key: "nama_sumber_dana",
      dataIndex: "nama_sumber_dana",
      onFilter: (value, record) => record.nama_sumber_dana.indexOf(value) === 0,
      sorter: (a, b) => a.nama_sumber_dana.localeCompare(b.nama_sumber_dana),
    },
    {
      title: "Jumlah",
      key: "jumlah",
      dataIndex: "jumlah",
      align: "right",
      onFilter: (value, record) => record.jumlah.indexOf(value) === 0,
      sorter: (a, b) => a.jumlah - b.jumlah,
      render: (jumlah) => formatRupiah(jumlah),
    },
    {
      title: "Keterangan",
      key: "keterangan",
      dataIndex: "keterangan",
    },
  ];

  if (kodeRole === `kepala_madrasah`) {
    columns.push({
      title: "Aksi",
      key: "aksi",
      render: (record) => (
        <Space key={`aksiP` + record.id}>
          <ButtonTableEdit
            onClick={() => handleEdit(record)}
            disabled={
              btnAction || fixedFunding.includes(record.kode_sumber_dana)
            }
          />
          <ButtonTableDelete
            disabled={
              btnAction || fixedFunding.includes(record.kode_sumber_dana)
            }
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                onOk() {
                  return handleDelete(record);
                },
                onCancel() {},
                okText: "Hapus",
                cancelText: "Batal",
                okType: "danger",
                centered: true,
                wrapClassName: "erkam-custom-modal",
              });
            }}
          />
        </Space>
      ),
    });
  }

  /** function handle tambah */
  const handleTambah = () => {
    setOpenModal(true);
    setTitle("Tambah");
    // setEnabledNilai(false);
    setID(uuidv4());
    form.resetFields();
  };

  const handleEdit = (record: any) => {
    setOpenModal(true);
    setTitle("Edit");
    setID(record.id);
    // setEnabledNilai(
    //   apbnBosSemester.includes(record.kode_sumber_dana) ? true : false,
    // );
    form.setFieldsValue({
      nilaiPendapatan: record.jumlah,
      keterangan: record.keterangan,
      sumberDana: record.kode_sumber_dana,
    });
  };

  const handleDelete = async (record: any) => {
    const response = await getRencanaPendapatanIndikatifLisAlokasi(record.id);
    if (response.length < 1) {
      try {
        await deleteRencanaPedapatanIndikatif(record.id);
        Modal.success({
          title: "Sukses",
          content: "Penghapusan Data Pendapatan Indikatif Berhasil",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
        const rencanaPendapatanIndikatif = await getPlanningAll(
          "rencana-pendapatan-indikatif",
          { tahun: auth.isTahun },
        );
        const rencanaRekapSumberDanaBelanja = await getPlanningAll(
          "rencana-rekap-sumber-dana-belanja",
          { tahun: auth.isTahun },
        );
        const dataTmp = {
          rencanaPendapatanIndikatif,
          rencanaRekapSumberDanaBelanja,
        };
        setTimeout(() => {
          dispatch(setStore(dataTmp));
        }, 100);
      } catch (error) {
        console.log(error);
      }
    } else {
      Modal.error({
        title: "Kesalahan",
        content:
          "Data tidak bisa dihapus karena sudah digunakan di rincian belanja",
        okType: "danger",
        centered: true,
        wrapClassName: "erkam-custom-modal",
      });
    }
  };

  const handleSave = async (values: any) => {
    setLoading(true);
    let namaSumber = tmpSumberDana.filter(
      (item: any) => item.kode === values.sumberDana,
    );
    let payload: any = {
      id: id,
      activated: "1",
      jumlah: values.nilaiPendapatan,
      kode_sumber_dana: values.sumberDana,
      nama_sumber_dana: namaSumber[0].nama,
      tahun: auth.isTahun,
      keterangan: values.keterangan,
    };
    if (title === "Tambah") {
      try {
        await postRencanaPendapatanIndikatif(payload);
        Modal.success({
          title: "Sukses",
          content: "Penambahan Data Pendapatan Indikatif Berhasil",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
        const rencanaPendapatanIndikatif = await getPlanningAll(
          "rencana-pendapatan-indikatif",
          { tahun: auth.isTahun },
        );
        const rencanaRekapSumberDanaBelanja = await getPlanningAll(
          "rencana-rekap-sumber-dana-belanja",
          { tahun: auth.isTahun },
        );
        const dataTmp = {
          rencanaPendapatanIndikatif,
          rencanaRekapSumberDanaBelanja,
        };
        setTimeout(() => {
          dispatch(setStore(dataTmp));
        }, 100);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await editRencanaPendapatanIndikatif(payload);
        Modal.success({
          title: "Sukses",
          content: "Penyimpanan Data Pendapatan Indikatif Berhasil",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
        const rencanaPendapatanIndikatif = await getPlanningAll(
          "rencana-pendapatan-indikatif",
          { tahun: auth.isTahun },
        );
        const rencanaRekapSumberDanaBelanja = await getPlanningAll(
          "rencana-rekap-sumber-dana-belanja",
          { tahun: auth.isTahun },
        );
        const dataTmp = {
          rencanaPendapatanIndikatif,
          rencanaRekapSumberDanaBelanja,
        };
        setTimeout(() => {
          dispatch(setStore(dataTmp));
        }, 100);
      } catch (error) {
        console.log(error);
      }
    }
    setOpenModal(false);
    setLoading(false);
  };

  const getPortalBos = async (values: any) => {
    const dataPortalBos = await getPlanningAll("portal-bos", {
      nsm: auth?.madrasah?.nsm,
      tahun: auth?.isTahun,
    });

    const tmpBos =
      values?.sumberDana === "apbn_bos_semester_1"
        ? "apbn_bos_semester1"
        : "apbn_bos_semester2";
    const tmoNilai = (dataPortalBos && dataPortalBos[`${tmpBos}`]) || "0";
    form.setFieldsValue({ nilaiPendapatan: tmoNilai });
  };

  const handleChange = (values: any) => {
    for (let obj in values) {
      if (obj === "sumberDana") {
        if (
          values[obj] === "apbn_bos_semester_1" ||
          values[obj] === "apbn_bos_semester_2"
        ) {
          // setEnabledNilai(true);
          getPortalBos(values);
        } else {
          // setEnabledNilai(false);
        }
      }
    }
  };

  return (
    <>
      <BreadCrumb routes={itemBreadcrumb} title="Pendapatan Indikatif" />
      <div className="m-5 p-5 bg-white shadow-md rounded">
        <div className="mb-4">
          <NotifMessage
            tanggalErkam={tmpRencanaTanggal}
            tanggalBkba={tmpRencanaTanggalBkba}
            module="pendapatanIndikatif"
            setAction={(action: boolean) => setBtnAction(action)}
          />
        </div>
        <div className="mb-4 flex justify-end">
          <div className="mr-4">
            <Space wrap>
              {kodeRole === `kepala_madrasah` && (
                <ButtonTambah onClick={handleTambah} disabled={btnAction} />
              )}
              <ButtonLog
                onClick={() => route.push("/rencana/indikatif/pendapatan/logs")}
              />
            </Space>
          </div>
          <InputSearch
            className="w-3/4"
            onChange={(e: any) => setSearch(e.currentTarget.value)}
          />
        </div>
        <div className="w-full">
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={dataTable}
            bordered
            pagination={{
              total: totalDataTable,
              position: ["bottomRight"],
              defaultPageSize: pageSize,
              defaultCurrent: page,
              showTotal: (total) => `Total ${total} items`,
              onChange(page, pageSize) {
                setPage(page);
                setPageSize(pageSize);
              },
            }}
          />
        </div>
      </div>
      <Modal
        open={openModal}
        title={`${title} Rencana Pendapatan`}
        onCancel={() => setOpenModal(!openModal)}
        footer={[
          <Button key="back" onClick={() => setOpenModal(!openModal)}>
            Batal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}>
            Simpan
          </Button>,
        ]}>
        <Form
          form={form}
          key="formPendapatanIndikatif"
          name="formPendapatanIndikatif"
          layout="vertical"
          onValuesChange={handleChange}
          onFinish={handleSave}>
          <Form.Item
            label="Sumber Dana"
            name="sumberDana"
            rules={[
              { required: true, message: "Sumber Dana tidak boleh kosong!" },
            ]}>
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Pilih Sumber Dana">
              {tmpSumberDana?.length &&
                tmpSumberDana
                  .filter(
                    (item: any) => !tmpFilterSumberDana.includes(item.kode),
                  )
                  .map((e: any, i: any) => {
                    return (
                      <Select.Option key={`role${i}`} value={e.kode}>
                        {e.nama}
                      </Select.Option>
                    );
                  })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Nilai Pendapatan"
            name="nilaiPendapatan"
            rules={[
              {
                required: true,
                message: "Nilai Pendapatan tidak boleh kosong!",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              // disabled={enabledNilai}
              prefix="Rp."
              placeholder="Silahkan isi Nilai Pendapatan"
            />
          </Form.Item>
          <Form.Item label="Keterangan" name="keterangan">
            <Input.TextArea placeholder="Keterangan" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
export default PaguIndikatifPendapatan;
